module.exports = __webpack_public_path__ + "static/media/self-service.8a7c6c94.svg";